import { type Theme } from 'hooks/useThemeChange.tsx'

interface LocalStorageItems {
  theme: Theme
  selectedTicketId: string
  isChatDetailOpen: boolean
}
class LocalStorageUtils {
  public getItem<T extends keyof LocalStorageItems>(
    key: T
  ): LocalStorageItems[T] | null {
    const item = localStorage.getItem(key)
    if (!item) return null
    return JSON.parse(item)
  }

  public setItem<T extends keyof LocalStorageItems>(
    key: T,
    value: LocalStorageItems[T]
  ): void {
    localStorage.setItem(key, JSON.stringify(value))
  }

  public removeItem<T extends keyof LocalStorageItems>(key: T): void {
    localStorage.removeItem(key)
  }

  public clear (): void {
    localStorage.clear()
  }

  public onChange (
    callback: (newKey: string, newValue: unknown) => void
  ): () => void {
    window.addEventListener('storage', (event: StorageEvent) => {
      callback(event.key ?? '', event.newValue)
    })

    return () => {
      window.removeEventListener('storage', (event: StorageEvent) => {
        callback(event.key ?? '', event.newValue)
      })
    }
  }
}

export default new LocalStorageUtils()
